export default __webpack_public_path__ + "static/hannah-7459c4fdf13b298126a139d08c90d2a3.png";